var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2199 21.41L39.7999 7.09003H36.8199L25.8999 19.52L17.1799 7.09003H7.10986L20.2999 25.88L7.10986 40.89H10.0899L21.6199 27.76L30.8299 40.89H40.8899L27.2199 21.4V21.41ZM23.1399 26.05L21.7999 24.18L11.1699 9.29003H15.7499L24.3299 21.31L25.6599 23.18L36.8099 38.8H32.2299L23.1299 26.05H23.1399Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitter);
export default __webpack_public_path__ + "static/media/x-twitter.80ee3030ba501e297d6b6e2d52709bbb.svg";
export { ForwardRef as ReactComponent };